import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dashboard } from './Dashboard';
import { showForm } from '../../store/formSlice';
import { Modal } from 'antd';
import { Title, Paragraph } from '../../components/Text';


const DashboardContainer = () => {
    const dispatch = useDispatch();
    const opened = useSelector(state => state.form.visible);
    const { hasChanges } = useSelector(state => state.form);

    const onFormShow = (key) => {
        if (key !== opened) {
            if (hasChanges) {
                Modal.confirm({
                    centered: true,
                    icon: null,
                    className: "sp-confirm-modal",
                    title: <Title h4 color="#E8AF1D">Warning</Title>,
                    content: <Paragraph>Changes will not be saved. Are you sure you want to close the form?</Paragraph>,
                    okText: "Close",
                    okButtonProps: {style: { height: "40px", padding: "0px 21px", background: "var(--sp-main-color)", borderRadius: "8px", border: "none" }},
                    cancelButtonProps: {type: "link", style:{ fontSize: "14px", color: "var(--sp-main-color)" }},
                    onOk() {
                        dispatch(showForm(key));
                    },
                    onCancel() {}
                });    
            } else {
                dispatch(showForm(key));
            }
        };
    };

    return(
        <Dashboard 
            showForm={(key) => onFormShow(key)}
        />
    );
};

export { DashboardContainer };